import { render, staticRenderFns } from "./Buses.vue?vue&type=template&id=a360cd08&scoped=true&"
import script from "./Buses.vue?vue&type=script&lang=js&"
export * from "./Buses.vue?vue&type=script&lang=js&"
import style0 from "./Buses.vue?vue&type=style&index=0&id=a360cd08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a360cd08",
  null
  
)

export default component.exports